import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';
import { firstValueFrom } from 'rxjs';
import { JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class GradeService {
  constructor(private httpService: HttpService) {}

  async getAllGrades() {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Grade}`),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getGradeByID(id: number): Promise<JwtPayload> {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Grade}/${id}`),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getGradesByIds(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.GradeByIDs}`, body),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async getAllSubscriptions(queryParams: object): Promise<JwtPayload> {
    try {
      const documents = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.subscription_log_table}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeTokenPagination(documents);
    } catch (error) {
      throw error;
    }
  }
}
